import Text from "components/Text";
import { FC, forwardRef, memo, useRef } from "react";
import { FaCheck } from "react-icons/fa";
import theme from "theme";
import useCombinedRefs from "utils/useCombinedRefs";
import { WithStyle } from "../../utils/WithStyle";
import {
    Container,
    HiddenCheckbox,
    StyledCheckbox,
    StyledCheckboxWrapper,
} from "./Checkbox.styled";
import { CheckboxProps } from "./types";

const Component: FC<CheckboxProps> = memo(
    forwardRef(
        ({
            ref,
            label,
            fullWidth,
            labelColor,
            id = "checkbox",
            labelWeight,
            size = "S",
            name,
            ...restProps
        }) => {
            const checkboxRef = useCombinedRefs<HTMLInputElement>(
                ref,
                useRef(null)
            );

            return (
                <Container fullWidth={fullWidth} htmlFor={name}>
                    <StyledCheckboxWrapper size={size}>
                        <HiddenCheckbox
                            type="checkbox"
                            id={id}
                            ref={checkboxRef}
                            {...restProps}
                        />
                        <StyledCheckbox>
                            <FaCheck color="#fff" />
                        </StyledCheckbox>
                    </StyledCheckboxWrapper>
                    <Text
                        variant="label"
                        color={labelColor || theme.colors.grey.dark}
                        fontWeight={labelWeight}
                    >
                        {label}
                    </Text>
                </Container>
            );
        }
    )
);

export const Checkbox: FC<CheckboxProps> & WithStyle = Object.assign(
    Component,
    {
        Style: Container,
    }
);
